import { Component, OnInit } from '@angular/core';
import { CallService } from '../../../services/call.service';

@Component({
  selector: 'app-call-initiate',
  templateUrl: './call-initiate.component.html',
  styleUrls: ['./call-initiate.component.scss']
})
export class CallInitiateComponent implements OnInit {
  availableAdmins$ = this.callService.availableAdmins$;
  callState$ = this.callService.callState$;

  constructor(public callService: CallService) {}

  ngOnInit(): void {
    const adminId = localStorage.getItem('managerId') || '';
    const role = localStorage.getItem('role') || '';
    const name = localStorage.getItem('name') || 'Admin';
    this.callService.joinSupport(adminId, role, name);
  }

  requestCall(adminId: string): void {
    this.callService.requestCall(adminId);
  }
}
